import { Component, createElement, type ReactNode } from "react";
import "react-dom";

import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";

interface IErrorLoadingProps {
    entityName: string;
    children: ReactNode;
}

interface IErrorLoadingState {
    hasError: boolean;
    error?: Error;
}

// todo maybe we should change this to not production? That way stack info is shown in test/staging/etc instead of just our locals
function reactIsInDevelomentMode() {
    return "_self" in createElement("div");
}

export class ErrorLoading extends Component<IErrorLoadingProps, IErrorLoadingState> {
    state: Readonly<IErrorLoadingState> = {
        hasError: false,
    };

    componentDidCatch(error: Error) {
        /** @todo log error */
        this.setState({
            hasError: true,
            error: error,
        });
    }

    render() {
        if (this.state.hasError) {
            let fullErrorMessage = <>An error occurred loading the {this.props.entityName}</>;

            if (reactIsInDevelomentMode()) {
                // add more stack info when in debug mode
                fullErrorMessage = (
                    <>
                        {fullErrorMessage}
                        <br />
                        {this.state.error}
                    </>
                );
            }

            return (
                <BTAlert
                    title="Error"
                    message={fullErrorMessage}
                    type="error"
                    data-testid="loadingError"
                />
            );
        }

        return this.props.children;
    }
}
